module.exports = __webpack_public_path__ + "static/media/envelope-square.084a350c.svg";